import React from 'react';
import Radium from 'radium';
import { NavLink } from 'react-router-dom';
import Select from 'react-select';

import projectConfig from 'config';

import PropTypes from 'prop-types';

import MenuIcon from 'assets/MenuIcon';

const GraphNavLink = ({ url, text }) => (
  <NavLink to={url} className="link">
    {text}
  </NavLink>
);

const styles = {
  menuWrapper: {
    backgroundColor: 'ffffff',
    position: 'absolute',
    top: '5px',
    left: '5px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    zIndex: 15,
  },
  openedStateToggleButton: {
    minWidth: '40px',
    overflow: 'visible',
  },
  closedMenuWrapper: {
    width: '40px',
    overflow: 'hidden',
  },
  openedMenuWrapper: {
    width: '250px',
  },
  menuItem: {
    margin: '0 7px 0 7px',
  },
};

const reactSelectStyles = {
  control: styles => ({ ...styles, width: 150 }),
};


class GraphMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpened: false,
    };
  }

  getNavLink() {
    const { pathname, basepath } = this.props;

    if (pathname.includes('tags')) {
      return (<GraphNavLink url={`${basepath}/editor`} text="View" />);
    }

    return (<GraphNavLink url={`${basepath}/tags`} text="Tags" />);
  }

  toggleOpenedState = () => {
    this.setState((state) => {
      const { isOpened } = state;
      return {
        isOpened: !isOpened,
      };
    });
  };

  render() {
    const { isOpened } = this.state;
    const { selectedLocaleOption, handleLocaleChange } = this.props;
    const wrapperStyles = isOpened ? [styles.menuWrapper, styles.openedMenuWrapper] : [styles.menuWrapper, styles.closedMenuWrapper];

    return (
      <div style={wrapperStyles}>
      </div>
    );
  }
}


GraphMenu.propTypes = {
  pathname: PropTypes.string.isRequired,
  basepath: PropTypes.string.isRequired,
  selectedLocaleOption: PropTypes.object.isRequired,
  handleLocaleChange: PropTypes.func.isRequired,
};

export default Radium(GraphMenu);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/components/GraphMenu.jsx